import { useQuery } from '@tanstack/react-query';

import { Libraries } from '@air/api';
import { type Library } from '@air/api/types';
import { ONE_HOUR } from '@air/utilities';

import { usePublicWorkspace } from '~/components/PublicWorkspaceProvider';

export const PUBLIC_LIBRARY_CUSTOM_FIELDS_QUERY_KEY = 'PUBLIC_LIBRARY_CUSTOM_FIELD';

export const getPublicLibraryCustomFieldsKey = (libraryId: string | undefined) => [
  PUBLIC_LIBRARY_CUSTOM_FIELDS_QUERY_KEY,
  { libraryId },
];

export type UsePublicLibraryCustomFieldsParams = {
  libraryId: Library['id'] | undefined;
};

export const usePublicLibraryCustomFields = ({ libraryId }: UsePublicLibraryCustomFieldsParams) => {
  const { workspaceId } = usePublicWorkspace();

  return useQuery({
    queryKey: getPublicLibraryCustomFieldsKey(libraryId),

    queryFn: () => {
      if (!workspaceId) {
        throw new Error('No workspace id');
      }

      if (!libraryId) {
        throw new Error('No library id');
      }

      return Libraries.listCustomFields({ workspaceId, libraryId });
    },
    enabled: !!workspaceId && !!libraryId,
    staleTime: ONE_HOUR,
  });
};
